import { configCatClient } from '../shared/modules/config-cat';
import { useFeatureFlagStore } from './feature-flag-store';

export default function useFeatureFlag() {
  const featureFlagStore = useFeatureFlagStore();

  const initFlags = async (userEmail: string): Promise<void> => {
    await configCatClient.forceRefresh(async () => {
      configCatClient.getValue(
        'notification',
        false,
        (value) => {
          featureFlagStore.setNotificationFlag(value);
        },
        { identifier: userEmail }
      );
    });
  };

  return {
    initFlags,
  };
}
